import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const DIRECTORY_BANNER_URL =
  `${BASE_URL}/rest/v2.0/directory-banner`;

export const DIRECTORY_URL =
  `${BASE_URL}/directoryCams?directoryJson=true&online=true&url=true`;

export const DIRECTORY_URL_COUNTS =
  `${BASE_URL}/directoryCounts?directoryJson=true&online=true&url=true`;

export const FILTERS_URL =
  `${BASE_URL}/rest/v1.0/directory/filters`;

export const FILTER_COLLECTIONS_URL =
  `${BASE_URL}/directory/search/user_{userId}`;

export const FILTER_COLLECTION_ITEMS_URL =
  `${FILTER_COLLECTIONS_URL}/search_{searchId}`;

export const HTML_NOTIFICATIONS_URL =
  `${BASE_URL}/profile/html5Notifications`;

export const NEW_FILTERS_URL =
  `${BASE_URL}/rest/v2.0/directory/filters`;

export const NEW_TAGS_URL =
  `${BASE_URL}/rest/v2.0/directory/tags`;

export const USER_CONSENT_URL =
  `${BASE_URL}/rest/v1.0/user/{username}/consent/{consentType}`;
